import React from 'react'
import { useAuth0 } from "@auth0/auth0-react"

export default function DataPictureTitles({ data, localData}) {

  const {user} = useAuth0();
  // if(localData.user) localData.name = user.given_name


  const genderEmoji = localData.gender==="male" ? "♂" : "♀️"
  return (
    <p className="data__picture--titles">
      <span><b>Lv</b>{localData.lvl}</span>
    
      {
        localData.user ? (
          <span>{user.given_name}</span>
        ):(
          <span>{localData.name.toUpperCase()}</span>
        )
      }

      <span className={localData.gender}>{genderEmoji}</span>
    </p>
  )
}